<template>
  <div class="kecheng">
    <kind-choose-view :show-kc="true" :type="117" @isOk="isOk" />
 
    <div v-if="list && list.length > 0" class="live">
      <div v-for="(item, index) in list" :key="index" class="item" @click="goPage(item)">
    
        <div style="overflow: hidden;" class="item-img">
          <img style="width: 100%;height: auto;" :src="item.surfacePlot">

        </div>
        <div class="detail" :class=" 'boutiqueBan' ">
          <div class="detail-title twoEllipsis">{{ item.courseName }}</div>
          <div class="flex-c m-t-10" :class=" 'boutiqueTxt' ">
            <div :class=" 'mr-5'">
              {{ dealType(item.teachingMethod) }}
            </div>
            <div :class=" 'mr-5'">
              {{ Math.floor(item.hourKsTime) }}课时
            </div>
          </div>

          <!-- 价格 -->
          <div class="flex-between-c price-box">
            <div class="price" :class="item.productLine == 2 ? 'boutiquePrice' : ''">
              <span class="price-icon">￥</span>{{ item.discountPrice || item.currentPrice }}
            </div>
            <div class="tips">
              <img class="img" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/Frame.png" object-fit="contain">
              人气值 {{ item.browseFrequency ? item.browseFrequency : 0 }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 暂无课程 -->
    <div style="margin: 0 auto;" v-if="!list || list.length == 0">
      <el-empty description="暂无数据"></el-empty>
    </div>
 
    <div class="flex-jc-c m-t-20">
      <el-pagination :total="total" :current-page="pageNum" :page-sizes="[12, 20, 28, 40]" :page-size="pageSize"
        :pager-count="5" background layout="total, sizes, prev, pager, next" @current-change="handleCurrentChange"
        @size-change="handleSizeChange" />
    </div>
  </div>
</template>
<script>
import KindChooseView from '@/components/kindChooseViewjpkc.vue'
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: { KindChooseView },
  data() {
    return {
      search: {},
      list: [],
      total: 0,
      pageSize: 12,
      pageNum: 1,
      loading: null
    }
  },
  created() {
    this.getList()
  },
  methods: {
    dealType(type) {
      let temp = null
      switch (type) {
        case 1:
          temp = '直播'
          break
        case 2:
          temp = '录播'
          break
        case 3:
          temp = '音频'
          break
        case 4:
          temp = '图文'
          break
        case 5:
          temp = '面授'
          break
        default:
          ''
      }
      return temp
    }, 
    goPage(item) {
      if (!item) {
        return
      }
      if (item.teachingMethod == 1) {
        const routeUrl = this.$router.resolve({
          path: '/zhiboclassxq',
          query: {
            id: item.id
          }
        })
        window.open(routeUrl.href, '_blank')
      } else if (item.teachingMethod == 2) {
        const routeUrl = this.$router.resolve({
          path: '/videoxq',
          query: {
            id: item.id
          }
        })
        window.open(routeUrl.href, '_blank')
      } 
    },
    async getList() {
      this.loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: '',
        background: 'rgba(0, 0, 0, 0.2)'
      })
      await homeClient
        .qbsJxyCourse(
         { pageSize: this.pageSize,
          pageNum: this.pageNum,
          // 将筛选组件选中的课程类型传给列表接口，选择全部时不传。
          teachingMethod: this.search.types || undefined,
          belongCollege: this.search.school ? this.search.school : undefined,
          belongProject: this.search.kind ? this.search.kind : undefined,
          belongMajor: this.search.zyId ? this.search.zyId : undefined,
          belongCourseTitle: this.search.kcId ? this.search.kcId : undefined,
          province: this.search.areaId ? this.search.areaId : undefined}
        )
        .then((res) => {
          this.total = res.data.total
          this.list = res.data.rows
        })
      this.loading.close()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    searchClick() {
      this.pageSize = 12
      this.pageNum = 1
      this.total = 0
      this.list = []
      this.getList()
    },
    isOk(val) {
      this.search = val
      this.searchClick()
    }
  }
}
</script>
<style lang="less" scoped>
.kecheng {
  padding-bottom: 24px;
}

.live {
  width: 1244px;
  margin-left: calc(50% - 610px);
  margin-bottom: 40px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  padding-top: 40px;

  .item {
    margin-bottom: 24px;
    width: 293px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    margin-right: 24px;

    &:nth-child(4n) {
      margin-right: 0px !important;
    }

    overflow: hidden;
    cursor: pointer;

    &:hover {
      box-shadow: 0px 4px 8px 1px rgba(153, 153, 153, 0.20000000298023224);
    }

    .item-img {
      width: 293px;
      height: 164.8125px;
      border-radius: 8px 8px 0px 0px;
      opacity: 1;
      object-fit: cover;
    }

    .boutiqueBan {
      background-image: url('https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/boutiqueBan.png');
      height: 150px;
      background-size: 100% 100%;

      .detail-title {
        color: #5a4629 !important;
      }

      .tips {
        color: #5a4629 !important;
      }
    }

    .detail {
      padding: 12px 16px;

      .boutiqueTxt {
        width: 255px;
        height: 26px;
        padding: 0px 8px;
        line-height: 26px;
        font-size: 12px;
        background: none;
        background-image: url('https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/boutiqueCoure.png');
        background-size: 100% 100%;
        color: #a57800;

        .mr-5 {
          margin-right: 5px;
        }
      }

      .detail-title {
        font-size: 16px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
        height: 48px;
      }

      .item-tips {
        height: 20px;
        background: #fff2e9;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        font-size: 12px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #ff7b1c;
        line-height: 18px;
        padding: 0px 8px;
      }

      .item-tips+.item-tips {
        margin-left: 8px;
      }

      .tips {
        font-size: 14px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #999999;
        line-height: 14px;

        .img {
          width: 12px;
          height: 12px;
          display: inline-block;
        }
      }

      .price-box {
        margin-top: 18px;

        .boutiquePrice {
          color: #5a4629 !important;
        }

        .price {
          font-family: Microsoft YaHei-Regular;
          color: #ff5d51;
          font-size: 18px;
          line-height: 18px;
          font-weight: Bold;

          .price-icon {
            font-size: 14px;
            line-height: 14px;
            font-weight: 400;
          }
        }
      }
    }
  }
}
</style>
